import React, { useEffect, useRef, useState } from "react";

import { Progress } from "components";

export const ProgressAnimated = ({ finalValue, text, onAnimationFinish = () => {} }) => {
  const interval = useRef(null);
  const [displayedValue, setDisplayedValue] = useState(0);

  useEffect(() => {
    interval.current = setInterval(() => {
      setDisplayedValue((val) => {
        if (val >= finalValue) {
          return finalValue;
        }
        return val + 1;
      });
    }, 1000 / finalValue);

    return () => clearInterval(interval.current);
  }, [finalValue]);

  useEffect(() => {
    if (parseInt(displayedValue) === parseInt(finalValue)) {
      clearInterval(interval.current);
      onAnimationFinish();
    }
  }, [displayedValue, finalValue, onAnimationFinish]);

  return (
    <>
      <div className="progress-stat-container">
        <span className="progress-stat">{displayedValue}</span>
        <span className="progress-stat-percent">%</span>
        <span className="progress-stat-explainer">&nbsp;{text}</span>
      </div>
      <Progress percent={displayedValue} type="line" showInfo={false} strokeColor="#100c06" strokeWidth={16} />
    </>
  );
};
